
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post-categories/[slug]",
      function () {
        return require("private-next-pages/post-categories/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post-categories/[slug]"])
      });
    }
  